import { useCallback } from 'react';

import { UserActionType } from '@kaltura-ott/tvpil-analytics';
import { convertRhinoAssetTypeToMediaType, RecordingAsset } from '@kaltura-ott/tvpil-shared';

import { useRailContext } from 'components/widgets/Rail/components/RailProvider';
import { useStableReactRouter } from 'context/stableReactRouterContext/stableReactRouterContext';
import { resolvePathToDetailsPage, userActionEvents } from 'utils';

import { isStandaloneRecordingAsset } from '../../utils';

interface Props {
  collectionType: string;
  recording: RecordingAsset;
  isFuture: boolean;
}

export const useInfoClickHandler = ({ recording, collectionType, isFuture }: Props) => {
  const { navigate, location } = useStableReactRouter();
  const { onCardClick } = useRailContext();
  const { state } = location;

  const isStandalone = isStandaloneRecordingAsset(recording);

  const mediaTypeParam = convertRhinoAssetTypeToMediaType(recording.type).toLowerCase();

  return useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (onCardClick) {
        onCardClick(recording.id);
      }

      const link = resolvePathToDetailsPage({
        id: recording.id,
        subtype: collectionType,
        mediaTypeParam,
        seriesId: recording.seriesId,
        isAggregatedSeriesRecord: !isStandalone,
        isProgramRecord: true,
        isFuture,
      });

      userActionEvents(UserActionType.details, recording.id, mediaTypeParam);

      navigate(link, { state: { goBackUrl: state?.goBackUrl } });
    },
    [
      collectionType,
      isStandalone,
      mediaTypeParam,
      navigate,
      onCardClick,
      recording.id,
      isFuture,
      recording.seriesId,
      state?.goBackUrl,
    ],
  );
};
